import { SIGNUP_MONTHS, SIGNUP_YEARS, SIGNUP_IS_DEV } from '../../constants';

export const SignupFormBilling = {
  bindings: {
    isDisabled: '<',
    isLoading: '<',
    chargifyData: '<',
    chargifyFields: '<',
    chargifySubscriptionId: '<',
    product: '<',
    text: '<',
    title: '@',
    onCancel: '&',
    onUpdate: '&',
  },

  template: `
    <form class="voome-form"
      ng-class="{ 'disabled': $ctrl.isDisabled }"
      id="chargifyForm"
      name="form"
      action="{{ $ctrl.action }}"
      method="post"
      novalidate>
      <fieldset>
        <div class="d-flex justify-content-between">
          <strong>
            {{ $ctrl.title }}
          </strong>
          <i class="logo logo-credit-cards">
            Visa - Amex - Mastercard
          </i>
        </div>
        <hr class="mt-1">
        <div class="mb-3">
          <form-group-row>
            <form-group-left>
              <form-label for="cardNumber">
                Number
                <span class="text-gray"
                  ng-if="$ctrl.isDev">
                  ({{ form.cardNumber.$viewValue.length || 0 }})
                </span>
              </form-label>
            </form-group-left>
            <form-group-right>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="fa fa-lock"></i>
                  </div>
                </div>
                <input class="form-control"
                  ng-class="{
                    'is-valid': $ctrl.chargifyData.cardNumber && form.cardNumber.$valid,
                    'is-invalid': $ctrl.chargifyData.cardNumber && form.cardNumber.$invalid
                  }"
                  id="cardNumber"
                  name="cardNumber"
                  type="tel"
                  ng-value="$ctrl.chargifyData.cardNumber"
                  ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"
                  ng-model="cardNumber"
                  ng-change="$ctrl.onUpdate({
                    key: 'cardNumber',
                    value: form.cardNumber.$viewValue
                  })"
                  focus-if="!$ctrl.isDisabled"
                  credit-card-number
                  required>
              </div>
              <form-errors
                field="form.cardNumber"
                errors="{
                  required: 'This is a required field.',
                  creditCardNumber: 'Must be a valid credit card number.',
                }">
              </form-errors>
            </form-group-right>
          </form-group-row>
          <form-group-row>
            <form-group-left>
              <form-label for="expirationMonth">
                Expiration Date
              </form-label>
            </form-group-left>
            <form-group-right>
              <div class="form-row">
                <div class="col">
                  <select class="form-control"
                    ng-class="{
                      'is-valid': $ctrl.chargifyData.expirationMonth && form.expirationMonth.$valid,
                      'is-invalid': $ctrl.chargifyData.expirationMonth && form.expirationMonth.$invalid,
                    }"
                    id="expirationMonth"
                    name="expirationMonth"
                    ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"
                    ng-value="$ctrl.chargifyData.expirationMonth || ''"
                    ng-model="expirationMonth"
                    ng-change="$ctrl.onUpdate({
                      key: 'expirationMonth',
                      value: form.expirationMonth.$viewValue
                    })"
                    credit-card-date="{
                      month: form.expirationMonth,
                      year: form.expirationYear
                    }"
                    required>
                    <option value="">Month</option>
                    <option
                      ng-repeat="option in $ctrl.months track by $index"
                      value="{{ option }}">
                      {{ option | padStart:2:0 }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <select class="form-control"
                    ng-class="{
                      'is-valid': $ctrl.chargifyData.expirationYear && form.expirationYear.$valid,
                      'is-invalid': $ctrl.chargifyData.expirationYear && form.expirationYear.$invalid,
                    }"
                    id="expirationYear"
                    name="expirationYear"
                    ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"
                    ng-value="$ctrl.chargifyData.expirationYear || ''"
                    ng-model="expirationYear"
                    ng-change="$ctrl.onUpdate({
                      key: 'expirationYear',
                      value: form.expirationYear.$viewValue
                    })"
                    credit-card-date="{
                      month: form.expirationMonth,
                      year: form.expirationYear
                    }"
                    required>
                    <option value="">Year</option>
                    <option
                      ng-repeat="option in $ctrl.years track by $index"
                      value="{{ option }}">
                      {{ option | padStart:2:0 }}
                    </option>
                  </select>
                </div>
                <div class="invalid-feedback d-flex px-2"
                  ng-show="(form.expirationMonth.$touched && form.expirationMonth.$invalid) || (form.expirationYear.$touched && form.expirationYear.$invalid)">
                  Must be a valid month/year expiration date.
                </div>
              </div>
            </form-group-right>
          </form-group-row>
        </div>
        <hr>
      </fieldset>
      <div class="row justify-content-end">
        <div class="col-md-8">
          <div class="form-group mb-4"
            ng-if="!$ctrl.chargifyData.subscriptionId">
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
              <input class="custom-control-input"
                id="termsAndConditions"
                type="checkbox"
                name="termsAndConditions"
                ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"
                ng-model="$ctrl.termsAndConditions"
                required>
              <label
                class="custom-control-label small"
                for="termsAndConditions">
                I have read and agree to the
                <a href="#"
                  data-toggle="modal"
                  data-target="#modalTerms">
                  terms & conditions.
                </a>
              </label>
            </div>
            <modal target="modalTerms">
              <modal-title>Terms & Conditions</modal-title>
              <modal-body>
                <terms-conditions></terms-conditions>
              </modal-body>
            </modal>
            <div class="custom-control custom-checkbox my-1 mr-sm-2"
              ng-if="$ctrl.text.couponTitle && $ctrl.text.couponTermsUri">
              <input class="custom-control-input"
                id="termsAndConditionsCoupon"
                type="checkbox"
                name="termsAndConditionsCoupon"
                ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"
                ng-model="$ctrl.termsAndConditionsCoupon"
                required>
              <label
                class="custom-control-label small"
                for="termsAndConditionsCoupon">
                I have read and agree to the
                <a ng-href="{{ $ctrl.text.couponTermsUri }}" target="_blank">
                  {{ $ctrl.text.couponTitle }} terms & conditions
                </a>
              </label>
            </div>
          </div>
          <input
            type="hidden"
            name="{{ name }}"
            value="{{ $ctrl.chargifyData[key] }}"
            ng-if="$ctrl.chargifyData[key]"
            ng-repeat="(key, name) in $ctrl.chargifyFields track by $index">
          <button-primary
            ng-type="submit"
            ng-disabled="$ctrl.isDisabled || $ctrl.isLoading || form.$invalid"
            ng-click="form.$valid && $ctrl.onSubmit()">
            <spinner is-loading="$ctrl.isLoading && form.$valid">
              <span ng-hide="$ctrl.chargifyData.subscriptionId">Submit</span>
              <span ng-show="$ctrl.chargifyData.subscriptionId">Submit</span>
            </spinner>
          </button-primary>
          <span class="pl-2" ng-hide="$ctrl.chargifySubscriptionId">
            <button-link
              ng-disabled="$ctrl.isDisabled || $ctrl.isLoading"
              ng-click="$ctrl.onCancel()">
              Cancel
            </button-link>
          </span>
        </div>
      </div>
    </form>`,

  controller($sce, $ngRedux, $scope) {
    'ngInject';

    return {
      $onInit() {
        this.months = SIGNUP_MONTHS;
        this.years = SIGNUP_YEARS;
        this.isDev = SIGNUP_IS_DEV;
      },

      $onChanges() {
        const endpoint = this.chargifySubscriptionId
          ? `subscriptions/${this.chargifySubscriptionId}/card_update`
          : 'signups';

        this.action = $sce.trustAsResourceUrl(
          `https://api.chargify.com/api/v2/${endpoint}`
        );
      },

      onSubmit() {
        // Disable inputs so only the hidden chargifyFields are submitted.
        this.isDisabled = true;

        // Show spinners, etc.
        this.isLoading = true;

        // Submit the form on the next tick.
        setTimeout(() => document.getElementById('chargifyForm').submit());
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupFormBilling.js